import { Card, Switch } from "@ttc3k/trekker";
import { ReactNode } from "react";
import { cva } from "styled-system/css";
import { Box, styled } from "styled-system/jsx";
import { NumericStepper } from "../NumericStepper";

const productCardSurfaceStyles = cva({
  base: {
    width: "full",
    outline: "0 transparent solid",
    transitionDuration: "normal",
    transitionProperty: "border, outline",
    transitionTimingFunction: "default",
    boxShadow: "none",
  },
  variants: {
    visual: {
      unChecked: {},
      checked: {
        borderColor: "border.dark",
        outlineWidth: "1px",
        outlineColor: "border.dark",
      },
    },
  },
  defaultVariants: {
    visual: "unChecked",
  },
});

const ProductCardSurface = styled(Card.Surface, productCardSurfaceStyles);

type ProductCardProps = {
  mainText: string;
  subText: string;
  onCheckedChange?: (v: boolean) => void;
  checked?: boolean;
  quantityEnabled?: boolean;
  quantity?: number;
  onQuantityChange?: (v: number) => void;
  maxQuantity?: number;
  minQuantity?: number;
  disabled?: boolean;
  footer?: ReactNode;
};

export const UpsellSelectionCard = ({
  mainText,
  subText,
  onCheckedChange,
  checked = false,
  quantityEnabled = false,
  quantity,
  onQuantityChange,
  maxQuantity,
  minQuantity,
  disabled = false,
  footer,
}: ProductCardProps) => {
  return (
    <ProductCardSurface visual={checked ? "checked" : "unChecked"}>
      <Card.Body bg="white" py={"250"}>
        <Card.BodyContent alignItems="center">
          <Card.Title mainText={mainText} subText={subText} />
          {quantityEnabled ? (
            <NumericStepper
              value={quantity}
              onChange={onQuantityChange}
              max={maxQuantity}
              min={minQuantity}
              disabled={disabled}
            />
          ) : (
            <Switch
              checked={checked}
              disabled={disabled}
              onCheckedChange={e => onCheckedChange?.(e.checked)}
            />
          )}
        </Card.BodyContent>
        {footer && <Box pt={"100"}>{footer}</Box>}
      </Card.Body>
    </ProductCardSurface>
  );
};
